module.exports = __webpack_public_path__ + "static/media/q-logo.462e972a.svg";